import script from "./noDataCustom.vue?vue&type=script&setup=true&lang=ts"
export * from "./noDataCustom.vue?vue&type=script&setup=true&lang=ts"

import "./noDataCustom.vue?vue&type=style&index=0&id=85839f74&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85839f74"]])

export default __exports__